// A chunk is a 16 × WORLD_HEIGHT × 16 column of blocks stored in a flat array.
// Pure data — no rendering concerns here.

import { Block } from './blocks';
import { CHUNK_SIZE_X, CHUNK_SIZE_Z, WORLD_HEIGHT } from './constants';

export class Chunk {
  readonly cx: number;
  readonly cz: number;
  readonly blocks: Uint8Array;
  /** True once the player has modified this chunk (used by save/streaming). */
  dirty = false;
  /** True once terrain has been generated. */
  generated = false;

  constructor(cx: number, cz: number) {
    this.cx = cx;
    this.cz = cz;
    this.blocks = new Uint8Array(CHUNK_SIZE_X * WORLD_HEIGHT * CHUNK_SIZE_Z);
  }

  static index(lx: number, y: number, lz: number): number {
    return (y * CHUNK_SIZE_Z + lz) * CHUNK_SIZE_X + lx;
  }

  get(lx: number, y: number, lz: number): Block {
    if (y < 0 || y >= WORLD_HEIGHT) return Block.Air;
    return this.blocks[Chunk.index(lx, y, lz)] as Block;
  }

  set(lx: number, y: number, lz: number, block: Block): void {
    if (y < 0 || y >= WORLD_HEIGHT) return;
    this.blocks[Chunk.index(lx, y, lz)] = block;
  }
}
